import { render, staticRenderFns } from "./live-reserve.vue?vue&type=template&id=54ec17b0&scoped=true&"
import script from "./live-reserve.vue?vue&type=script&lang=js&"
export * from "./live-reserve.vue?vue&type=script&lang=js&"
import style0 from "./live-reserve.vue?vue&type=style&index=0&id=54ec17b0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ec17b0",
  null
  
)

export default component.exports